module.exports = {"id":"221445","name":"Wu Lei","rating":"73","photo":"./data/images/photos/3/221445.png","club":{"name":"Agents libres","logo":"./data/images/clubs/Agentslibres.png"},"positions":["BU","MD","MG","ATT"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/WuLei0.json
// module id = 4364
// module chunks = 0